import commands from './commands';

export default (editor, opts = {}) => {
    const options = {
        ...{
            panelId: 'views-container',
            appendTo: '',
            openState: {
                cv: '65%',
                pn: '35%',
            },
            closedState: {
                cv: '85%',
                pn: '15%',
            },
            codeViewOptions: {},
            preserveWidth: false,
            editJs: false,
            clearData: false,
            cleanCssBtn: true,
            htmlBtnText: 'Apply',
            cssBtnText: 'Apply',
            cleanCssBtnText: 'Delete',
        },
        ...opts,
    };

    commands(editor, options);
};
